export default __webpack_public_path__ + "cropped-community.344cc443.png";